import DispatchBrandCategory from '@/components/tecdocSettings/TecdocMenuCreate/DispatchBrandCategory'
import React from 'react'

const ManagementCatalogAssignBrands = () => {
    return (
        <div>
            <DispatchBrandCategory />
        </div>
    )
}

export default ManagementCatalogAssignBrands